/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap } from '../../../..';

import eyeVisible from '../../../../../../../../styles/yurstrap/app/images/eye-visible.svg';
import eyeHidden from '../../../../../../../../styles/yurstrap/app/images/eye-hidden.svg';

const propTypes = {
    ...Abstrap.propTypes,
    visible: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    visible: false,
};

class PasswordSymbol extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-form__icon-container',
            'js-symbol-password',
            className,
        ];
    }

    renderChildren() {
        const { visible, onClick } = this.props;
        if (visible) {
            return (
                <img
                    className="c-form__icon c-form__icon_visible"
                    src={eyeVisible}
                    alt="Cacher le mot de passe"
                    onClick={onClick}
                />
            );
        }
        return (
            <img
                className="c-form__icon"
                src={eyeHidden}
                alt="Afficher le mot de passe"
                onClick={onClick}
            />
        );
    }

}

PasswordSymbol.propTypes = propTypes;

PasswordSymbol.defaultProps = defaultProps;

export default PasswordSymbol;
